import './style.scss';
import logo from '../../../assets/images/ayawaLogo.png';

const Terms = () => {
    return(
        <div className={'terms-page'}>
            <img src={logo}/>
            <div className={'terms-title'}>
                <h1>General Terms and Conditions</h1>
                <p>Effective from 3rd February, 2023</p>
            </div>
            <p>
                1. Scope of application
            </p>
            <p>
                1.1. These General Terms and Conditions ("Terms") apply to all users (The “User” or “You”) of the services accessible through https://Ayawa.io (the “Website”) and the Ayawa mobile application (the “App”) (together the “Services”) provided outside the European Union by Ayawa Pty Ltd (“Ayawa”, the “Company” or “Us” or “We”) registered at the address Unit 8/35 Biscayne Way, Jandakot, WA, 6164, Australia...
            </p>
            <p>
                1.2. You may access these Terms on our website or in the App at any time, enabling You to view, download, save and read them at any time. You can also access and print them when creating an Account. l.
            </p>
            <p>
                1.3. You accept these Terms and if you do not accept them, please do not use the App. .
            </p>
            <p>
                1.4 We may make changes or vary these Terms without prior notice to you. Should you not accept any changes to these Terms, please cease using the Services and / or uninstall the App.
            </p>
            <p>
                1.5 You agree you will not sell, transfer, license, or assign any account or rights without Our express written permission.
            </p>
            <p>
                1.6 Your account is unique to You and You agree that you shall not share, loan, or otherwise provide access to this account with any third party
            </p>
            <p>
                2. Services
            </p>
            <p>
                2.1. Ayawa may provide You with a wide range of content related to mental well-being and mindfulness, in particular guided meditations, sleep stories, blog articles, and music. This content may be created by Ayawa or a third party and used under the license. ..
            </p>
            <p>
                3. Use of the Services
            </p>
            <p>
                3.1. Account registration
            </p>
            <p>
                3.1.1. In order to use the Services, You must create an Account ("User Account" or “Account”) by following the registration instructions in the App or on the Website. When registering an Account, You may be asked to provide Ayawa with certain personal data such as email address, and to choose a password.
            </p>
            <p>
                3.1.2 You may create an account using alternate methods using third-party authentication services such as, but not limited to, Apple ID or Google Accounts. You agree that by the use of these methods to create an account you accept all associated third-party terms and conditions.
            </p>
            <p>
                3.1.3 Registration is free. By registering an account with Us, You agree that you will be bound by these Terms. .
            </p>
            <p>
                3.1.4. By registering an account with Us, You declare that (i) You are legally allowed to enter into binding contracts; (ii) all registration information You submit is true and accurate; (iii) You will be responsible for the accuracy and completeness of such information in the future; and (iv) your use of the Services does not violate any applicable law.
            </p>
            <p>
                3.1.5 You may terminate Your account at any time or We may terminate your account for a breach of these Terms under the provisions set out under clause X. Termination
            </p>
            <p>
                3.2. Free Services Some parts of our Services are available to You unlimited and free of charge. The scope of these services may change in the future and You agree to any such change.
            </p>
            <p>
                3.3. Subscription Services We may offer Services which require a paid subscription to access ot use. You agree that You will not attempt to access such services without valid payment and that Services available under Your subscription may change in the future
            </p>
            <p>
                3.4 Payment for Services
            </p>
            <p>
                3.4.1 You agree that we may offer a Subscription to access some Services that will be paid for in advance using a valid method of payment accepted by Us. You authorize us to charge any form of payment You provide, in connection with your subscription.
            </p>
            <p>
                3.4.2 All Subscriptions are for a fixed duration unless otherwise specified and You agree that You will pay prior to accessing these Services unless utilizing an offer for free access made by US
            </p>
            <p>
                3.4.3 You agree that unless canceled prior to the expiry of the duration of the Subscription, the Subscription may automatically renew unless canceled prior to its renewal.
            </p>
            <p>
                3.4.4 You may terminate Your Subscription Services at any time and will have access to all of the features of your Subscription until the duration of that Subscription expires.
            </p>
            <p>
                3.4.5 Should you cancel a Subscription prior to its expiry, You will not be entitled to a refund for any unused portion of your Subscription.
            </p>
            <p>
                3.5. Access to the Services
            </p>
            <p>
                3.5.1 To use the Services, You must have Internet access and a device that can utilize the Services...
            </p>
            <p>
                3.5.2 We shall not be liable for any costs incurred by You in accessing the Services such as access or data charges incurred by You from a third party.
            </p>
            <p>
                3.6 Third-Party Content
            </p>
            <p>
                3.6.1 You may be provided content created by other individuals or organizations not associated with Us. This content (“Third Party Content”) is provided to You under these Terms and may or may not be separately identified as originating from these Third Parties and you agree that this content is not the responsibility or under Our control.
            </p>
            <p>
                4. Termination
            </p>
            <p>
                4.1. Termination y You
            </p>
            <p>
                4.1.1. You may cancel your Account or any Subscription at any time..
            </p>
            <p>
                4.1.2. Upon termination of your Account You will receive a confirmation of receipt of your cancellation to the email address that You provided during registration.
            </p>
            <p>
                4.1.3. Please note that if You subscribe through the Apple App Store, or Google Play Store You can cancel your subscription by disabling auto-renewal of paid in-app subscriptions using the method provided in each of these services..
            </p>
            <p>
                4.1.4. If You do not cancel your subscription before the end of your current subscription period, the subscription will continue for a further period.
            </p>
            <p>
                4.1.5. We retain the right to terminate Your account or any subscription as set out in these Terms..
            </p>
            <p>
                4.2. Termination by Ayawa
            </p>
            <p>
                4.2.1. We may suspend or terminate your use of the Services for cause, including, without limitation, fraud on your part. Such termination or suspension may be affected immediately and without prior notice, if it is not reasonable for Us to notify You in advance, taking into Account the circumstances of the individual case and weighing the interests of both parties. We may terminate your use of the Services for cause, where, you:
            </p>
            <div>
                <ul>
                    <li>copy or download, share or otherwise deal content from the Services without our permission or in breach of these terms</li>
                    <li>Your use of the Services may constitute a violation of any applicable laws or regulations</li>
                    <li>You attempt to access the services without a valid account or without payment</li>
                    <li>Attempt payment utilizing a payment method You are not authorized to use; or</li>
                    <li>for any cause which breaches other provisions of these terms or any law in effect at the time.</li>
                </ul>
            </div>

            <p>
                Should we suspend or terminate your account you will not be eligible for any refund of any amount paid to Us and not utilized by You.
            </p>
            <p>
                5. Refunds
            </p>
            <p>
                5.1 Subject to applicable laws We may offer a refund to You where You have made payment and the Services provided are very different from those described, are shown to be faulty or not fit for purpose.
            </p>
            <p>
                5.2 We are not obligated to provide you a refund where you simply changed their mind, found the Services cheaper somewhere else, or decided You did not like the Services, had no use for them, or through Your own misuse of the Services.
            </p>
            <p>
                6. Warranties
            </p>
            <p>
                6.1 The Service, including, without limitation, is provided on an "as is", "as available" and "with all faults" basis.
            </p>
            <p>
                6.2 Some or all features available through the Service may not be available in your region due to various factors and We do not guarantee access to the Service.
            </p>
            <p>
                6.3 To the fullest extent permissible by law, neither We nor any of their employees, managers, officers, or agents make any representations or warranties, or endorsements of any kind whatsoever, express or implied, as to
            </p>
            <div>
                <ul>
                    <li>The Service;</li>
                    <li>Third Party Content; or</li>
                    <li>Security associated with the transmission of information to Us or via the Service.</li>
                </ul>
            </div>
            <p>
                In addition, We hereby disclaim all warranties, express or implied, including, but not limited to, the warranties of merchantability, fitness for a particular purpose, non-infringement, title, custom, trade, quiet enjoyment, system integration, and freedom from computer virus.
            </p>
            <p>
                6.4 We do not represent or warrant that the Service will be error-free or uninterrupted; that defects will be corrected; or that the Service or the server that makes the Service available is free from any harmful components, including, without limitation, viruses.
            </p>
            <p>
                6.5 we do not make any representations or warranties that the information on the Service is accurate, complete, or useful. You acknowledge that your use of the Service is at your sole risk.
            </p>
            <p>
                6.6 We do not warrant that your use of the Service is lawful in any particular jurisdiction, and specifically disclaim such warranties. Some jurisdictions limit or do not allow the disclaimer of implied or other warranties so the above disclaimer may not apply to you to the extent such jurisdiction's law is applicable to you and these Terms.
            </p>
            <p>
                6.7 By accessing or using the Service, You represent and warrant that your activities are lawful in every jurisdiction where You access or use the Service.
            </p>
            <p>
                6.8 We do not endorse any Third Party Content and specifically disclaim any responsibility or liability to any person or entity for any loss, damage (whether actual, consequential, punitive, or otherwise), injury, claim, liability, or other cause of any kind or character based upon or resulting from any content.
            </p>
            <p>
                7. Limitation of liability; waiver
            </p>
            <p>
                7.1 Under no circumstances will We be liable to You for any loss or damages of any kind (including, without limitation, for any direct, indirect, economic, exemplary, special, punitive, incidental or consequential losses or damages) that are directly or indirectly related to:
            </p>
            <div>
                <ul>
                    <li>The Service;</li>
                    <li>Third Party Content;</li>
                    <li>Your use of, inability to use, or the performance of the service;</li>
                    <li>Any action taken in connection with an investigation by Us or law enforcement authorities regarding your or any other party's use of the service;</li>
                    <li>Any action taken in connection with copyright or other intellectual property owners;</li>
                    <li>Any errors or omissions in the Service's operation; or</li>
                    <li>Any damage to any user's computer, mobile device, or other equipment or technology including, without limitation, damage from any
                        security breach or from any virus, bugs, tampering, fraud, error,
                        omission, interruption, defect, delay in operation or transmission, computer
                        line or network failure or any other technical or other malfunction; including,
                        without limitation, damages for lost profits, loss of goodwill, loss of data,
                        work stoppage, accuracy of results, or computer failure or malfunction, even if foreseeable or
                        even if We have been advised of or should have known of the possibility of such damages, whether
                        in an action of contract, negligence, strict liability or tort (including, without limitation,
                        whether caused in whole or in part by negligence, acts of God, telecommunications failure, or theft or
                        destruction of the service).</li>
                </ul>
            </div>
            <p>
                7.2 In no event will We be liable to you or anyone else for loss, damage, or injury, including, without limitation, death or personal injury. Some states do not allow the exclusion or limitation of incidental or consequential damages, so the above limitation or exclusion may not apply to You. In no event will Our total liability to You for all damages, losses, or causes or action exceed one hundred United States Dollars (USD 100.00).
            </p>
            <p>
                7.3 You agree that in the event you incur any damages, losses, or injuries that arise out of Our acts or omissions, the damages, if any, caused to You are not irreparable or sufficient to entitle You to an injunction preventing any exploitation of any website, service, property, product or other content owned or controlled by Us, and You will have no rights to enjoin or restrain the development, production, distribution, advertising, exhibition or exploitation of any website, property, product, service, or other content owned or controlled by the Us or related parties.
            </p>
            <p>
                7.4 We are not responsible for the actions, content, information, or data of third parties, and you release Us, Our directors, officers, employees, and agents from any claims and damages, known and unknown, arising out of or in any way connected with any claim You have against any such third parties.
            </p>
            <p>
                8. Indemnity
            </p>
            <p>
                8.1 You (and also any third party for whom you operate an account or activity on the Service) agree to defend (at Our request), indemnify and hold Us harmless from and against any claims, liabilities, damages, losses, and expenses, including without limitation, reasonable attorney's fees and costs, arising out of or in any way connected with any of the following (including as a result of your direct activities on the Service or those conducted on your behalf):
            </p>
            <div>
                <ul>
                    <li>Your access to or use of the Service;</li>
                    <li>Your breach or alleged breach of these Terms;</li>
                    <li>Your violation of any third-party right, including without limitation, any intellectual property right, publicity, confidentiality, property or privacy right;</li>
                    <li>Your violation of any laws, rules, regulations, codes, statutes,
                        ordinances or orders of any governmental and quasi-governmental
                        authorities, including, without limitation, all regulatory, administrative and legislative authorities; or</li>
                    <li>Any misrepresentation made by You.</li>
                </ul>
            </div>
            <p>
                8.2 You will cooperate as fully required by Us in the defense of any claim. We reserve the right to assume the exclusive defense and control of any matter subject to indemnification by you, and You will not in any event settle any claim without Our prior written consent.
            </p>
            <p>
                8.3 Time Limitation on Claims You agree that any claim You may have arising out of or related to your relationship with Us must be filed within one (1) year after such claim arose; otherwise, Your claim is permanently barred.
            </p>
            <p>
                9. Disclaimer
            </p>
            <p>
                9.1. We are a provider of content related to health, well-being, meditation, and wellness. We are not a health care provider or a medical device provider, nor do our Services constitute medical advice.
            </p>
            <p>
                9.2. We make no representations, warranties, or assurances that the Services provide any therapeutic benefit.
            </p>
            <p>
                9.3. All health information, links to the Services, and/or recommendations or other materials, whether provided by Us or by any Third Party, are provided for non-binding general informational purposes only.
            </p>
            <p>
                9.4. Recommendations and other materials provided by Us are intended to enhance, but not replace, the relationship that exists between You and your healthcare providers. We assume no liability for any consequences resulting from You having read or others having told You about these recommendations or other materials. Rather, You assume sole responsibility for your decisions and actions.
            </p>
            <p>
                10. Intellectual Property
            </p>
            <p>
                10.1. We grant You the non-exclusive, non-sub licensable and non-transferable right, limited in time and withdrawable at any time, to access the Services via the Website or App provided by Us Solely for the purposes set forth herein and to use them accordingly. Any further use of the Website or the App, including the images, characters, icons, or product descriptions displayed, is not permitted without`s express consent.
            </p>
            <p>
                10.2. When using the Website or the App, it is prohibited to copy, modify or create derivative works based on the information displayed therein and the software related to the Services. It is further prohibited to extract (e.g. by "scraping") the services depicted on the Website or the App and/or to reuse the information outside the Website or the App.
            </p>
            <p>
                11. Data Protection
            </p>
            <p>
                In the context of the use of Our Services, it is necessary to process certain personal data of our users. For the processing of personal data by Us, Our Privacy Policy applies, as well as on Our website and in the app. You can read which personal data We process, for what purpose they are processed, and on what legal basis.
            </p>
            <p>
                12. Governing Law and Venue
            </p>
            <p>
                12. 1 These Terms are governed by and construed in accordance with the laws of Western Australia, without giving effect to any principles of conflicts of law.
            </p>
            <p>
                12.2 These Terms WILL SPECIFICALLY NOT BE GOVERNED BY THE UNITED NATIONS CONVENTIONS ON CONTRACTS FOR THE INTERNATIONAL SALE OF GOODS, IF OTHERWISE APPLICABLE.
            </p>
            <p>
                12.3 If any provision of these Terms is held to be unlawful, void, or for any reason unenforceable during arbitration or by a court of competent jurisdiction, then that provision will be deemed severable from these Terms and will not affect the validity and enforceability of any remaining provisions. Our failure to insist upon or enforce strict performance of any provision of these Terms will not be construed as a waiver of any provision or right.
            </p>
            <p>
                12.4 No waiver of any of these Terms will be deemed a further or continuing waiver of such term or condition or any other term or condition.
            </p>
            <p>
                12.5 We reserve the right to change this dispute resolution provision, but any such changes will not apply to disputes arising before the effective date of the amendment.
            </p>
            <p>
                12.6 This dispute resolution provision will survive the termination of any or all your transactions with Us.
            </p>
            <p>
                13. Entire Agreement
            </p>
            <p>
                13.1 These Terms constitute the entire agreement between You and Us and govern your use of the Service, superseding any prior agreements between You and Us.
            </p>
            <p>
                13.2 You will not assign the Terms or assign any rights or delegate any obligations hereunder, in whole or in part, whether voluntarily or by operation of law, without Our prior written consent.
            </p>
            <p>
                13.3 Any purported assignment or delegation by you without Our prior written consent will be null and void.
            </p>
            <p>
                13.4 We may assign these Terms or any rights hereunder without Your consent.
            </p>
            <p>
                13.5 If any provision of these Terms is found by a court of competent jurisdiction to be invalid or otherwise unenforceable, the parties nevertheless agree that such portion will be deemed severable from these Terms and will not affect the validity and enforceability of the remaining provisions, and the remaining provisions of the Terms remain in full force and effect.
            </p>
            <p>
                13.6 Neither the course of conduct between the parties nor trade practice will act to modify the Terms. These Terms do not confer any third-party beneficiary rights.
            </p>
        </div>
    )
}
export default Terms;